const initialState = {
    responseCoveragesList: {},
    responseCoverages: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "COVERAGES_LIST_RESPONSE":
            newState.responseCoveragesList = action.value
            break;
        case "COVERAGES_RESPONSE":
            newState.responseCoverages = action.value
            break;
        case "UPLOAD_IMAGE_BACKOFFICE_RESPONSE":
            newState.responseUploadImage = action.value
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;